import { computed, setProperties } from "@ember/object";
import { classNames } from "@ember-decorators/component";
import { allLevels, buttonDetails } from "discourse/lib/notification-levels";
import { i18n } from "discourse-i18n";
import DropdownSelectBoxComponent from "select-kit/components/dropdown-select-box";
import { pluginApiIdentifiers, selectKitOptions } from "select-kit/components/select-kit";
import NotificationsButtonRow from "./notifications-button/notifications-button-row";
const NotificationsButton = dt7948.c(class NotificationsButton extends DropdownSelectBoxComponent {
  content = allLevels;
  nameProperty = "key";
  getTitle(key) {
    const {
      i18nPrefix,
      i18nPostfix
    } = this.selectKit.options;
    return i18n(`${i18nPrefix}.${key}${i18nPostfix}.title`);
  }
  modifyComponentForRow(_, content) {
    if (content) {
      setProperties(content, {
        title: this.getTitle(content.key)
      });
    }
    return NotificationsButtonRow;
  }
  modifySelection(content) {
    content = content || {};
    const title = this.getTitle(this.buttonForValue.key);
    setProperties(content, {
      title,
      label: title,
      icon: this.buttonForValue.icon
    });
    return content;
  }
  get buttonForValue() {
    return buttonDetails(this.value);
  }
  static {
    dt7948.n(this.prototype, "buttonForValue", [computed("value")]);
  }
}, [pluginApiIdentifiers("notifications-button"), selectKitOptions({
  autoFilterable: false,
  filterable: false,
  i18nPrefix: "",
  i18nPostfix: ""
}), classNames("notifications-button")]);
export default NotificationsButton;